import React, { PureComponent } from "react";
import SettingHospital from "./components/settingHospital/index";
import SettingDepartment from "./components/settingDepartment";
import SettingUser from "./components/settingUser";
import SettingRole from "./components/settingRole";
import SettingRoom from "./components/settingRoom";
import Grouping from "./components/grouping";
import Operate from "./components/operate";
import CustomSignature from "./components/customSignature";

import { Layout, Menu, Card } from "antd";

const { Sider, Content } = Layout;

class Jurisdiction extends PureComponent {
	state = {
		selectedMenu: "2"
	};

	returnPage = () => {
		this.props.history.goBack();
	};

	handleSelectMenu = (e) => {
		this.setState({
			selectedMenu: e.key
		});
	};

	render() {
		const { selectedMenu } = this.state;
		const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
		const roleList = JSON.parse(localStorage.getItem("roleList")) || [];
		return (
			<>
				<Layout className="pageWrap" style={{ minWidth: "1260px" }}>
					<Sider className="siderWrap" theme="light" trigger={null}>
						<Card
							className="doubleBox paddingB"
							size="small"
							title={
								<p style={{ display: "flex", alignItems: "center" }}>
									<img
										alt=""
										width="18"
										height="18"
										style={{ marginRight: "8px" }}
										src={require("@/assets/image/j.png").default}
									/>
									权限管理
								</p>
							}
							style={{ width: 300 }}>
							<Menu className="menuWrap" mode="inline" onClick={this.handleSelectMenu} selectedKeys={[selectedMenu]}>
								{userInfo.IS_ADMINISTRATOR === "1" ? (
									<Menu.Item key="6">
										<span>分组管理</span>
									</Menu.Item>
								) : null}
								{userInfo.IS_ADMINISTRATOR === "1" ? (
									<Menu.Item key="7">
										<span>运营管理</span>
									</Menu.Item>
								) : null}
								{userInfo.IS_ADMINISTRATOR === "1" || roleList.indexOf("二级管理员") > -1 ? (
									<Menu.Item key="1">
										<span>医院管理</span>
									</Menu.Item>
								) : null}
								<Menu.Item key="2">
									<span>科室管理</span>
								</Menu.Item>
								<Menu.Item key="3">
									<span>房间管理</span>
								</Menu.Item>

								<Menu.Item key="4">
									<span>用户管理</span>
								</Menu.Item>
								{userInfo.IS_ADMINISTRATOR === "1" || roleList.indexOf("二级管理员") > -1 ? (
									<Menu.Item key="5">
										<span>角色管理</span>
									</Menu.Item>
								) : null}
								{userInfo.IS_ADMINISTRATOR === "1" ? (
									<Menu.Item key="8">
										<span>自定义签名</span>
									</Menu.Item>
								) : null}
							</Menu>
						</Card>
					</Sider>
					<Layout>
						{/* Content 内容部分 */}
						<Content className="contentWrap">
							{/* 医院管理 */}
							{selectedMenu === "1" && (userInfo.IS_ADMINISTRATOR === "1" || roleList.indexOf("二级管理员") > -1) ? (
								<SettingHospital />
							) : null}
							{/* 分组管理 */}
							{selectedMenu === "6" && userInfo.IS_ADMINISTRATOR === "1" ? <Grouping /> : null}
							{/* 科室管理 */}
							{selectedMenu === "2" ? <SettingDepartment /> : null}

							{/* 房间管理 */}
							{selectedMenu === "3" ? <SettingRoom /> : null}

							{/* 用户管理 */}
							{selectedMenu === "4" ? <SettingUser /> : null}

							{/* 角色管理 */}
							{selectedMenu === "5" && (userInfo.IS_ADMINISTRATOR === "1" || roleList.indexOf("二级管理员") > -1) ? (
								<SettingRole />
							) : null}
							{/* 运营管理 */}
							{selectedMenu === "7" && userInfo.IS_ADMINISTRATOR === "1" ? <Operate /> : null}

							{/* 自定签名 */}
							{selectedMenu === "8" && userInfo.IS_ADMINISTRATOR === "1" ? <CustomSignature /> : null}
						</Content>
					</Layout>
				</Layout>
			</>
		);
	}
}

export default Jurisdiction;
